import { render, staticRenderFns } from "./MovieSimple.vue?vue&type=template&id=d09028da&"
import script from "./MovieSimple.vue?vue&type=script&lang=js&"
export * from "./MovieSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d09028da')) {
      api.createRecord('d09028da', component.options)
    } else {
      api.reload('d09028da', component.options)
    }
    module.hot.accept("./MovieSimple.vue?vue&type=template&id=d09028da&", function () {
      api.rerender('d09028da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/MovieSimple.vue"
export default component.exports